import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { completed } from './events';

type State = {
  isInited: boolean;
  error: Nullable<string>;
};

export const slice = createSlice({
  name: 'system',
  initialState: {
    isInited: false,
    error: null,
  } satisfies State as State,
  selectors: {
    isInited: (state) => state.isInited,
    error: (state) => state.error,
  },
  reducers: {
    init: (state) => {
      state.isInited = false;
      state.error = null;
    },
    errorOccured: (state, { payload: { message } }: PayloadAction<Error>) => {
      state.error = message;
    },
  },
  extraReducers: (builder) =>
    builder.addCase(completed, (state, { payload: { result } }) => {
      state.isInited = result;
    }),
});
